// Expose React and ReactDOM on window for Module Federation remotes.
//
// The host loads these via SystemJS (AMD path), which does NOT set window
// globals. Native webpack MF remotes need them available on window so the
// host's share-scope factory can provide them through the shared scope.
import React from 'react';
import ReactDOM from 'react-dom';

if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOM;
}
